export default "__VITE_ASSET__Sr9JcyHo__"